export default __webpack_public_path__ + "static/media/logo-tae-collecte-gestion-des-mif-transparent.3e393871.png";